<div class="container-fluid" *ngIf="contentVisble" style="padding: 0">
  <div class="row">
    <div class="col-md-12 text-right"></div>
  </div>

  <div class="ng-Header col-xs-12">
    <i nz-icon nzType="unordered-list" nzTheme="outline"></i> STP Search
  </div>
  <form
    nz-form
    [formGroup]="searchingForm"
    class="ant-advanced-search-form"
    style="
      padding: 24px;
      background: #fbfbfb;
      border: 1px solid #d9d9d9;
      border-radius: 6px;
    "
    (ngSubmit)="onSearch()"
  >
    <div nz-row [nzGutter]="16">
      <!-- STP Name -->
      <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8">
        <nz-form-item>
          <nz-form-label nzRequired>STP Name</nz-form-label>
          <nz-form-control>
            <input
              nz-input
              placeholder="Enter STP Name"
              formControlName="stpName"
            />
          </nz-form-control>
        </nz-form-item>
      </div>

      <!-- Application ID -->
      <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8">
        <nz-form-item>
          <nz-form-label nzRequired>Application ID</nz-form-label>
          <nz-form-control>
            <input
              nz-input
              placeholder="Enter Application ID"
              formControlName="stpApplicationId"
            />
          </nz-form-control>
        </nz-form-item>
      </div>

      <!-- Ownership -->
      <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8">
        <nz-form-item>
          <nz-form-label nzRequired>Ownership</nz-form-label>
          <nz-form-control>
            <nz-select
              nzShowSearch
              nzAllowClear
              nzPlaceHolder="Select Ownership Type"
              formControlName="stpOwnerShipStatusId"
            >
              <nz-option
                *ngFor="let data of stpOwnershipTypeList"
                [nzValue]="data.id"
                [nzLabel]="data.typeName"
              >
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>

      <!-- District -->
      <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8">
        <nz-form-item>
          <nz-form-label nzRequired>District</nz-form-label>
          <nz-form-control>
            <nz-select
              nzShowSearch
              nzAllowClear
              nzPlaceHolder="Select District"
              formControlName="sysDistrictId"
            >
              <nz-option
                *ngFor="let data of districtList"
                [nzValue]="data.id"
                [nzLabel]="data.districtName"
              >
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>

      <!-- Occupation -->
      <!-- <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8">
        <nz-form-item>
          <nz-form-label nzRequired>Occupation</nz-form-label>
          <nz-form-control>
            <input
              nz-input
              placeholder="Enter Occupation Name"
              formControlName="occupationName"
            />
          </nz-form-control>
        </nz-form-item>
      </div> -->

      <!-- Submission -->
      <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8">
        <nz-form-item>
          <nz-form-label nzRequired>Submission</nz-form-label>
          <nz-form-control>
            <nz-select
              nzShowSearch
              nzAllowClear
              nzPlaceHolder="Select Submission Status"
              formControlName="submissionStatusId"
            >
              <nz-option
                *ngFor="let data of applicationSubmissionStatusList"
                [nzValue]="data.id"
                [nzLabel]="data.name"
              >
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>

      <!-- Review -->
      <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8">
        <nz-form-item>
          <nz-form-label nzRequired>Review</nz-form-label>
          <nz-form-control>
            <nz-select
              nzShowSearch
              nzAllowClear
              [(ngModel)]="selectedReviewStatus"
              [ngModelOptions]="{ standalone: true }"
              nzPlaceHolder="Select Review Status"
              (ngModelChange)="onReviewStatusChange($event)"
            >
              <nz-option
                *ngFor="let data of applicationReviewList"
                [nzValue]="data.code"
                [nzLabel]="data.name"
              >
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>

      <!-- Approval -->
      <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="8">
        <nz-form-item>
          <nz-form-label nzRequired>Approval</nz-form-label>
          <nz-form-control>
            <nz-select
              nzShowSearch
              nzAllowClear
              [(ngModel)]="selectedApprovalStatus"
              [ngModelOptions]="{ standalone: true }"
              nzPlaceHolder="Select Approval Status"
              (ngModelChange)="onApprovalStatusChange($event)"
            >
              <nz-option
                *ngFor="let data of approvalList"
                [nzValue]="data.code"
                [nzLabel]="data.name"
              >
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <!-- Buttons -->
    <div nz-row nzJustify="end" style="margin-top: 24px">
      <button nz-button nzType="primary" htmlType="submit">Search</button>

      <button
        nz-button
        nzType="default"
        style="margin: 0 12px"
        type="button"
        (click)="onRefresh()"
      >
        Refresh
      </button>
    </div>
  </form>

  <div class="ng-Header col-xs-12 mt-4">
    <i nz-icon nzType="unordered-list" nzTheme="outline"></i>
    {{ assignedOnly ? 'List of Assigned Renewal STP Applications' : 'List of Renewal STP Applications' }}
  </div>
  <div nz-col [nzSpan]="24">
    <nz-table
      #basicTable
      [nzData]="stpApplicationDto"
      nzTableLayout="fixed"
      nzShowSizeChanger
      nzBordered
      nzSize="middle"
      nzAlign="middle"
      [nzFrontPagination]="false"
      [nzTotal]="total"
      [(nzPageSize)]="size"
      [nzShowTotal]="totalRowRangeTemplate"
      [(nzPageIndex)]="page"
      (nzQueryParams)="onQueryParamsChange($event)"
      [nzPaginationPosition]="'both'"
      [nzScroll]="{ x: '1300px' }"
    >
      <ng-template
        #totalRowRangeTemplate
        let-range="range"
        let-total
        style="text-align: left"
      >
        <div style="text-align: left">
          Showing {{ range[0] }}-{{ range[1] }} of {{ total }} items
        </div>
      </ng-template>
      <thead>
        <tr>
          <th style="text-align: center; width: 60px" rowspan="1">Sl.</th>
          <th rowspan="2" nzColumnKey="stp_name" [nzSortFn]="true">
            Name of STP
          </th>
          <th rowspan="2" nzColumnKey="application_id" [nzSortFn]="true">
            Application ID
          </th>
          <th rowspan="2" nzColumnKey="created_at" [nzSortFn]="true">
            Date of Application
          </th>
          <th rowspan="2" nzColumnKey="registration_no" [nzSortFn]="true">
            Registration Number
          </th>
          <th rowspan="2" nzColumnKey="approval_date" [nzSortFn]="true">
            Date of Approval
          </th>
          <th rowspan="2">Type of Ownership</th>
          <th rowspan="2">Ministry</th>
          <th rowspan="2">Agency</th>
          <th rowspan="2">District</th>
          <th rowspan="2">Application Status</th>
          <th rowspan="2">Approval Status</th>
          <th rowspan="2" nzRight style="width: 155px">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of basicTable.data; let i = index">
          <td style="text-align: center">{{ (page - 1) * size + 1 + i }}</td>
          <td>
            <span>
              <a
                [routerLink]="[
                  '/home/stp-registration/stp-application-view-renew-reapply',
                ]"
                [queryParams]="{
                  stpMainId: data.stpMainId,
                  stpMainDumpId: data.stpMainDumpId
                }"
                target="_blank"
                routerLinkActive="router-link-active"
                >{{ data.stpName }}</a
              >
            </span>
          </td>
          <td>
            <a
              [routerLink]="[
                '/home/stp-registration/stp-application-view-renew-reapply',
              ]"
              [queryParams]="{
                stpMainId: data.stpMainId,
                stpMainDumpId: data.stpMainDumpId
              }"
              target="_blank"
              routerLinkActive="router-link-active"
              >{{ data.applicationId }}</a
            >
          </td>
          <td>
            {{ data.applicationDate | date: "dd-MM-yyyy" }}
          </td>

          <!-- A renewal in progress has no registration number of its own yet; show it only once approved -->
          <td>{{ data.dumpApproval == true ? data.registrationId : '' }}</td>
          <td>
            {{ data.approvalDate | date: "dd-MM-yyyy" }}
          </td>
          <td>{{ data.ownerType }}</td>
          <td>{{ data.ministryName }}</td>
          <td>{{ data.agencyName }}</td>
          <td>{{ data.districtName }}</td>
          <td>
            <span
              class="badge {{
                data.applicationStatus
                  ? data.applicationStatus.toLowerCase() == 'completed'
                    ? 'badge-success'
                    : 'badge-primary'
                  : 'badge-primary'
              }}"
              style="font-size: 10px"
              >{{
                data.applicationStatus ? data.applicationStatus : "On Going"
              }}
            </span>
            <span
              *ngIf="data.isTempRejected == false"
              class="badge badge-success"
              style="font-size: 10px"
            >
              Accepted
            </span>
            <span
              *ngIf="data.isTempRejected == true"
              class="badge badge-danger"
              style="font-size: 10px"
            >
              Correction Requested
            </span>
          </td>
          <td>
            <span
              *ngIf="data?.inspectionApplicationStatusId == 15"
              class="badge badge-success"
              style="font-size: 10px"
            >
              Inspection Scheduled
            </span>
            <span
              *ngIf="data?.inspectionApplicationStatusId == 17"
              class="badge badge-success"
              style="font-size: 10px"
            >
              Inspection Completed
            </span>
            <span
              *ngIf="data?.inspectionApplicationStatusId == 19"
              class="badge badge-success"
              style="font-size: 10px"
            >
              Scrutiny Completed
            </span>
            <span
              *ngIf="data?.inspectionApplicationStatusId == 20"
              class="badge badge-success"
              style="font-size: 10px"
            >
              Decision Completed
            </span>
            <span
              class="badge {{
                data.dumpApproval == true ? 'badge-success' : 'badge-warning'
              }}"
              style="font-size: 10px"
            >
              {{ data.dumpApproval == true ? "Approved" : "Not Approved" }}
            </span>
          </td>
          <td nzRight>
            <span class="row justify-content-center media-button">
              <!-- <button [appRequiredPermission]="applicationPermissions.stpRegistration.dashBoard.readPermission"
                  class="mr-1"
                  nz-button
                  nzType="primary"
                  title="Edit Form"
                  [routerLink]="['/home/stp-registration/edit-dash-board/'+ data?.createdBy]"
                  [nzSize]="'small'">
                  <i nz-icon nzType="form" nzTheme="outline"></i>
                  </button> -->

              <!-- <button
                [appRequiredPermission]="
                  applicationPermissions.stpRegistration.stpApplication
                    .updateSTPNamePermission
                "
                class="mr-1"
                nz-button
                type="submit"
                nzType="primary"
                title="Update STP Name"
                [routerLink]="[
                  '/home/stp-registration/stp-name-update/',
                  data.stpMainId,
                ]"
                [nzSize]="'small'"
              >
                <i nz-icon nzType="edit" nzTheme="outline"></i>
              </button> -->

              <button
                class="mr-1"
                nz-button
                type="submit"
                nzType="primary"
                title="Download Certificate"
                [disabled]="!data.approval"
                (click)="downloadCertificate(data.stpMainId)"
                [nzSize]="'small'"
              >
                <i nz-icon nzType="container" nzTheme="outline"></i>
              </button>

              <button
                [appRequiredPermission]="
                  applicationPermissions.stpRegistration.stpApplication
                    .updateSTPNamePermission
                "
                class="mr-1"
                nz-button
                nzType="danger"
                type="submit"
                title="RollBack this STP User"
                [disabled]="
                  !(
                    data.applicationStatus?.toLowerCase() == 'completed' &&
                    !data.approval == true
                  ) ||
                  data.inspectionApplicationStatusId != null ||
                  rollbackButtonDisabled
                "
                (click)="openRollbackModal(data)"
                [nzSize]="'small'"
              >
                <i nz-icon nzType="rollback" nzTheme="outline"></i>
              </button>

              <!-- Renewal/reapply applications cannot be deleted; only a new draft STP/SAC can. -->

              <!-- <button
                  [appRequiredPermission]="
                    applicationPermissions.stpRegistration.stpApplication
                      .mailCertificatePermission
                  "
                  class="mr-1"
                  nz-button
                  nzType="primary"
                  type="submit"
                  title="Send this certificate to STP User"
                  [disabled]="!data.approval"
                  nz-popconfirm
                  nzPopconfirmTitle="Are you sure about sending this certificate to STP User?"
                  nzPopconfirmPlacement="topCenter"
                  (nzOnConfirm)="mailCertificate(data.stpMainId)"
                  [nzSize]="'small'"
                >
                  <i nz-icon nzType="mail" nzTheme="outline"></i>
                </button> -->
              <!-- <button
                [appRequiredPermission]="
                  applicationPermissions.stpRegistration.stpApplication
                    .approveSTPPermission
                "
                *ngIf="data.applicationStatus?.toLowerCase() == 'completed'"
                class="mr-1"
                nz-button
                nzType="primary"
                type="submit"
                title="Approve this STP User"
                [disabled]="data.approval"
                (click)="setApproved(data)"
                [nzSize]="'small'"
              >
                <i nz-icon nzType="check" nzTheme="outline"></i>
              </button> -->
            </span>

            <span class="row justify-content-center media-button">
              <a
                *ngIf="
                  data.applicationStatus?.toLowerCase() == 'completed' &&
                  data.isRenewed
                "
                class="mr-1 mt-2"
                nz-button
                nz-tooltip
                nzTooltipTitle="Schedule Inspection"
                nzTooltipPlacement="bottomLeft"
                nz-button
                nzType="primary"
                [nzSize]="'small'"
                [routerLink]="[
                  '/home/stp-registration/inspection-scheduling/' +
                    data.stpMainId,
                  data.isRenewed ? 'renewal' : 'reapply',
                ]"
                target="_blank"
                routerLinkActive="router-link-active"
                [appRequiredPermission]="
                  applicationPermissions.stpRegistration
                    .stpRenewReapplyApplication
                    .inspectionSchedulingRenewReapplyButtonPermission
                "
              >
                <i nz-icon nzType="schedule" nzTheme="outline"></i>
              </a>

              <a
                *ngIf="
                  data.applicationStatus?.toLowerCase() == 'completed' &&
                  data.isRenewed
                "
                class="mr-1 mt-2"
                nz-button
                nz-tooltip
                nzTooltipTitle="Complete Inspection"
                nzTooltipPlacement="bottomLeft"
                nz-button
                nzType="primary"
                [nzSize]="'small'"
                [routerLink]="[
                  '/home/stp-registration/inspection-completion/' +
                    data.inspectionId,
                  data.isRenewed ? 'renewal' : 'reapply',
                ]"
                target="_blank"
                routerLinkActive="router-link-active"
                [appRequiredPermission]="
                  applicationPermissions.stpRegistration
                    .stpRenewReapplyApplication
                    .inspectionCompletionRenewReapplyButtonPermission
                "
              >
                <i nz-icon nzType="check-circle" nzTheme="outline"></i>
              </a>

              <a
                *ngIf="
                  data.applicationStatus?.toLowerCase() == 'completed' &&
                  data.isRenewed
                "
                class="mr-1 mt-2"
                nz-tooltip
                nzTooltipTitle="Scrutiny Result"
                nzTooltipPlacement="bottomLeft"
                nz-button
                nzType="primary"
                [nzSize]="'small'"
                [routerLink]="[
                  '/home/stp-registration/result-scrutiny/' + data.inspectionId,
                  data.isRenewed ? 'renewal' : 'reapply',
                ]"
                target="_blank"
                routerLinkActive="router-link-active"
                [appRequiredPermission]="
                  applicationPermissions.stpRegistration
                    .stpRenewReapplyApplication
                    .resultScrutinyRenewReapplyButtonPermission
                "
              >
                <i nz-icon nzType="security-scan" nzTheme="outline"></i>
              </a>

              <a
                *ngIf="
                  data.applicationStatus?.toLowerCase() == 'completed' &&
                  data.isRenewed
                "
                class="mr-1 mt-2"
                nz-button
                nz-tooltip
                nzTooltipTitle="Decision"
                nzTooltipPlacement="bottomLeft"
                nz-button
                nzType="primary"
                [nzSize]="'small'"
                [routerLink]="[
                  '/home/stp-registration/final-decision/' + data.inspectionId,
                  data.isRenewed ? 'renewal' : 'reapply',
                ]"
                target="_blank"
                routerLinkActive="router-link-active"
                [appRequiredPermission]="
                  applicationPermissions.stpRegistration
                    .stpRenewReapplyApplication
                    .finalDecisionRenewReapplyButtonPermission
                "
              >
                <i
                  nz-icon
                  nzType="fund-projection-screen"
                  nzTheme="outline"
                ></i>
              </a>
            </span>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>
</div>

<ng-container *ngIf="!userInfo.id">
  <app-captcha (verifyStatus)="captchVerificationStatus($event)"></app-captcha>
</ng-container>

<app-footer></app-footer>

<nz-modal
  [nzWidth]="700"
  [(nzVisible)]="isStpBasicInfoModalVisible"
  nzTitle="STP Basic Information"
  (nzOnCancel)="handleCancel()"
  (nzOnOk)="handleOk()"
>
  <ng-container *nzModalContent>
    <div>
      <nz-descriptions [nzColumn]="2">
        <nz-descriptions-item nzSpan="2" nzTitle="Name of STP"
          >{{ stpBasicData.stpName }}
        </nz-descriptions-item>
        <nz-descriptions-item nzSpan="2" nzTitle="Name of STP in Bangla"
          >{{ stpBasicData.stpNameBangla }}
        </nz-descriptions-item>
        <nz-descriptions-item nzSpan="2" nzTitle="Name of Ministry/ Division"
          >{{ stpBasicData.ministryName }}
        </nz-descriptions-item>
        <nz-descriptions-item nzSpan="2" nzTitle="Name of Agency">{{
          stpBasicData.agencyName
        }}</nz-descriptions-item>
        <nz-descriptions-item nzTitle="Type of STP">{{
          stpBasicData.stpType
        }}</nz-descriptions-item>
        <nz-descriptions-item nzTitle="Type of Ownership">{{
          stpBasicData.ownershipType
        }}</nz-descriptions-item>
        <nz-descriptions-item nzTitle="Year of Establishment"
          >{{ stpBasicData.establishYear | date: "yyyy" }}
        </nz-descriptions-item>
        <nz-descriptions-item nzTitle="Location of the STP">{{
          stpBasicData.locationName
        }}</nz-descriptions-item>
        <nz-descriptions-item nzTitle="Country">{{
          stpBasicData.country
        }}</nz-descriptions-item>
        <nz-descriptions-item nzTitle="Division/State">{{
          stpBasicData.division
        }}</nz-descriptions-item>
        <nz-descriptions-item nzTitle="District/City">{{
          stpBasicData.district
        }}</nz-descriptions-item>
        <nz-descriptions-item nzTitle="Upazilla/Sub-district">{{
          stpBasicData.upazilla
        }}</nz-descriptions-item>
        <nz-descriptions-item nzSpan="2" nzTitle="House, Road, Village Area"
          >{{ stpBasicData.address }}
        </nz-descriptions-item>
        <nz-descriptions-item nzTitle="Contact number">{{
          stpBasicData.orgContact
        }}</nz-descriptions-item>
        <nz-descriptions-item nzTitle="Email address">{{
          stpBasicData.orgEmail
        }}</nz-descriptions-item>
      </nz-descriptions>
    </div>
  </ng-container>
</nz-modal>

<nz-modal
  [(nzVisible)]="isVisible"
  (nzOnCancel)="handleCancel()"
  [nzClosable]="true"
  [nzOkText]="modalOkText"
  [nzWidth]="700"
  nzTitle="Please select an approval date"
  (nzOnOk)="submitApprovalDate()"
>
  <ng-container *nzModalContent>
    <form nz-form [formGroup]="approvalForm" (onSubmit)="submitApprovalDate()">
      <nz-date-picker
        nzFormat="dd-MM-yyyy"
        [nzDisabledDate]="disabledDate"
        placeholder="Approval Start From"
        formControlName="approvalDateFromAdmin"
      ></nz-date-picker>
    </form>
  </ng-container>
</nz-modal>

<nz-modal
  [(nzVisible)]="isRollbackModalVisible"
  nzTitle="Rollback STP"
  (nzOnCancel)="handleRollbackCancel()"
  (nzOnOk)="handleRollbackOk()"
  [nzWidth]="700"
  [nzBodyStyle]="{ 'max-height': '500px', 'overflow-y': 'auto' }"
>
  <ng-container *nzModalContent>
    <nz-divider nzText="Add Remarks"></nz-divider>

    <textarea
      nz-input
      [(ngModel)]="rollbackRemarks"
      rows="3"
      placeholder="Enter remarks"
    ></textarea>

    <nz-divider nzText="Rollback History"></nz-divider>

    <nz-table
      #historyTable
      [nzData]="stpRollbackHistory"
      [nzBordered]="true"
      nzSize="small"
      [nzPageSize]="5"
      [nzFrontPagination]="true"
      [nzShowPagination]="true"
      [nzShowTotal]="totalRowRangeTemplate"
      [nzNoResult]="noRollbackHistoryTpl"
    >
      <ng-template
        #totalRowRangeTemplate
        let-range="range"
        let-total
        style="text-align: left"
      >
        <div style="text-align: left">
          Showing {{ range[0] }}-{{ range[1] }} of {{ total }} items
        </div>
      </ng-template>
      <thead>
        <tr>
          <th nzWidth="60px">#</th>
          <th nzWidth="120px">Type</th>
          <th>Remarks</th>
          <th nzWidth="160px">Date</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let item of historyTable.data; let i = index">
          <td>
            {{
              (historyTable.nzPageIndex - 1) * historyTable.nzPageSize + i + 1
            }}
          </td>
          <td>
            <nz-tag
              [nzColor]="
                item.rollbackApplicationTypeName === 'Renew' ? 'blue' : 'orange'
              "
            >
              {{ item.rollbackApplicationTypeName }}
            </nz-tag>
          </td>
          <td style="word-break: break-word; white-space: pre-line">
            {{ item.remarks }}
          </td>
          <td>{{ item.createdAt | date: "dd-MM-yyyy hh:mm a" }}</td>
        </tr>
      </tbody>
    </nz-table>

    <ng-template #noRollbackHistoryTpl>
      <nz-empty nzNotFoundContent="No rollback history found"></nz-empty>
    </ng-template>
  </ng-container>
</nz-modal>
